import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';

import { firebaseApp } from './firebase';

//Use Server
const functions = getFunctions(firebaseApp);

//Use emulator
/* const storage = getStorage();
connectStorageEmulator(storage, 'localhost', 9199);
const functions = getFunctions(firebaseApp);
connectFunctionsEmulator(functions, 'localhost', 5001); */

export const getPdfUrl = httpsCallable(functions, 'getPdfUrl');

export const emailSender = httpsCallable(functions, 'emailSender');

export const sendWaitingListEmail = httpsCallable(
  functions,
  'sendWaitingListEmail'
);

export const sendContactUsEmail = httpsCallable(
  functions,
  'sendContactUsEmail'
);

// Gets a RevenueCat Offering
export const getRCOffering = httpsCallable(functions, 'getRCOffering');

// Gets a RevenueCat customer, it will return all customer information and subscriptions
export const getRCCustomer = httpsCallable(functions, 'getRCCustomer');

// Gets a valid referralCode from the referralCodes collection, or null
export const getValidReferralCode = httpsCallable(
  functions,
  'getValidReferralCode'
);

// Gets Stripe available products for the user
export const getStripeProducts = httpsCallable(functions, 'getStripeProducts');

// Creates a new Stripe Checkout session so the user can purchase a plan
export const createStripeCheckoutSession = httpsCallable(
  functions,
  'createStripeCheckoutSession'
);

// Creates a Stripe Customer Portal session so user can manage/cancel his subscription
export const createStripeCustomerPortalSession = httpsCallable(
  functions,
  'createStripeCustomerPortalSession'
);

export const createToken = httpsCallable(functions, 'createToken');

export const queryOpenAICollectionBrainStream = httpsCallable(
  functions,
  'queryOpenAICollectionBrainStream'
);

export const createCollectionBrain = httpsCallable(
  functions,
  'createCollectionBrain'
);

export const getBrainEnabledCollections = httpsCallable(
  functions,
  'getBrainEnabledCollections'
);

export const deleteCollectionBrain = httpsCallable(
  functions,
  'deleteCollectionBrain'
);

export const deleteCollectionDocument = httpsCallable(
  functions,
  'deleteCollectionDocument'
);

export const toggleCollectionDocumentBrainIndex = httpsCallable(
  functions,
  'toggleCollectionDocumentBrainIndex'
);

export const getUserLimitsAndUsage = httpsCallable(
  functions,
  'getUserLimitsAndUsage'
);

export const checkLicenseKey = httpsCallable(functions, 'checkLicenseKey');

export const checkAndAssignLicenseSeat = httpsCallable(
  functions,
  'checkAndAssignLicenseSeat'
);

export const verifyUserEmail = httpsCallable(functions, 'verifyUserEmail');

export const subscribeToSharedCollection = httpsCallable(
  functions,
  'subscribeToSharedCollection'
);

export const createCollectionUrl = httpsCallable(
  functions,
  'createCollectionUrl'
);

export const deleteCollectionUrl = httpsCallable(
  functions,
  'deleteCollectionUrl'
);

export const applyForInvitation = httpsCallable(
  functions,
  'applyForInvitation'
);

export const deleteCollection = httpsCallable(functions, 'deleteCollection');
